import React from 'react'
import Header from './components/Header';
import Footer from './components/Footer';
import { useState,useEffect } from 'react';
import './styles/motoStyles.css';
import lotus from '../src/images/lotus.png';

const Cheq = () => {
  const [fadeOut, setFadeOut] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

    
    useEffect(() => {
      const handleScroll = () => {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        if (scrollTop > 50) {
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      };
    
      window.addEventListener("scroll", handleScroll);
      handleScroll();
    
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);
  return (
    <div>
      <div className={`moto ${fadeOut ? 'fade-out' : ''}`}>
        <h1>Cheque Bouncing here at KWA</h1>
      </div>
      <Header scrolled={scrolled}/>
      <div className='justify-content-center d-flex align-items-center w-100 fs-4' style={{minHeight:'100vh',padding:'10%',paddingTop: '5%',paddingBottom: '5%'}}>
        <img src={lotus} alt='' className='lotus'></img>
        <div className=''><p><span className="highlight">Cheque bouncing</span>, a prevalent issue in India's financial landscape, poses significant challenges to businesses and individuals alike. In accordance with the <span className="highlight">Negotiable Instruments Act</span>, <span className="highlight">1881</span>, the dishonour of a cheque due to insufficient funds or other reasons constitutes a criminal offense, demanding swift and adept legal intervention.</p>
        <br />

        <p><span className="kwa">KWA</span> is well-equipped to handle the complexities of cheque bouncing cases in India. With a team of experienced legal professionals who are well-versed in the <span className="highlight">Negotiable Instruments Act</span> and relevant legal precedents, we provide comprehensive legal advice and representation to clients facing cheque bouncing disputes.</p>
<br />

<p>We take a strategic approach to each case, carefully analysing the details to develop customized solutions that meet our clients' needs. Whether through negotiation, mediation, or litigation, we are committed to protecting our clients' rights and interests.</p>
<br />

<p>Our firm has a proven track record of success in handling cheque bouncing cases, demonstrating our expertise in this area of law. Clients can trust in our <span className="highlight">proficiency</span>, <span className="highlight">integrity</span>, and <span className="highlight">dedication</span> to achieving positive outcomes, even in challenging situations.</p>
<br />

<p>By choosing our law firm to handle your cheque bouncing concerns, you can expect <span className="highlight">top-notch</span> legal representation marked by <span className="highlight">thoroughness</span>, <span className="highlight">skill</span>, and <span className="highlight">unwavering support</span>.</p></div>
      </div>
      <Footer />
    </div>
  )
}

export default Cheq
